export const chartOptions = {
  maintainAspectRatio: false,
  layout: {
    padding: {
      left: 0,
      right: 0,
      bottom: 0,
      top: 40,
    },
  },
  plugins: {
    legend: {
      display: false,
    },
  },
  scales: {
    x: {
      grid: {
        display: false,
      },
      ticks: {
        padding: 15,
      },
    },
    y: {
      beginAtZero: true,
      ticks: {
        padding: 15,
      },
    },
  },
}
